// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1iVil","banner":"Footer_banner__3ycNz"};